<template>

  <div class="w100">


    <div v-for="e in purcaseItemsExtend">

        <span v-if="Number(e.type) === Number(1)" class="table">

                        <!--Need copy fron sellInOne i you would like to use-->

            <!--<tr>-->
            <!--<td class="">-->
            <!--&lt;!&ndash;<span :for="'text-input' + e.itemKey " class="form-control-label">{{Helper.getValueByIdAndKeyFromObjectArray("name", elements, e.itemKey) }}</span>&ndash;&gt;-->
            <!--<span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>-->
            <!--</td>-->
            <!--<td class="text-right price" style="">-->
            <!--</td>-->
            <!--<td class="text-right price" style="">-->
            <!--<span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemValue}}</span>-->
            <!--<small class=""> -</small>-->
            <!--</td>-->
            <!--<td class="icons" v-if="justDisplay=='false'">-->
            <!--<div class="input-group">-->
            <!--<a class="btn_delrow input-group-addon " v-on:click="delrow(e.id)"><div class=" "><i class="fa fa-times"></i></div></a>-->
            <!--</div>-->
            <!--</td>-->
            <!--</tr>-->


        </span>
        <span v-if="Number(e.type) === Number(2)||Number(e.type) === Number(3)" class="table">


            <!--Need copy fron sellInOne i you would like to use-->

            <!--<tr>-->
            <!--<td class="">-->
            <!--<span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>-->
            <!--</td>-->
            <!--<td class="text-right price" style="">-->
            <!--<span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemValue}}</span>-->
                <!--&lt;!&ndash;<span id="text-display' + e.itemKey + '" class="" data-id="' + e.itemKey + '">' + e.itemValue + '</span>&ndash;&gt;-->
            <!--<small class=""> {{$t('global.piece')}}</small>-->
            <!--</td>-->
            <!--<td class="text-right price" style="">-->
            <!--<span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{ (Number(e.default_price) * e.itemValue) }}</span>-->
            <!--<small class=""> -</small>-->
            <!--</td>-->
            <!--<td class="icons" v-if="justDisplay=='false'">-->
            <!--<div class="input-group">-->
            <!--<a class="btn_delrow input-group-addon " v-on:click="delrow(e.id)" data-id="' + i + '"><div class=" "><i class="fa fa-times"></i></div></a>-->
            <!--</div>-->
            <!--</td>-->
            <!--</tr>-->

        </span>


    </div>

        <div v-if="Number(discount_price)>0">
            <span class="table">
                <tr>
                    <td class=" extensionLineX">
                        <span class="form-control-label">Kedvezmény</span>
                    </td>
                    <td class=" text-right text-nowrap extensionLineX">
                        <span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>
                        <small class=""> -</small>
                    </td>
                </tr>
            </span>
        </div>

        <div v-if="Number(sum)>0">
            <span class="table">
                <tr>
                    <td class="extensionLineX">
                        <span class="form-control-label">Teljes összeg</span>
                    </td>
                    <td class="text-right text-nowrap extensionLineX">
                        <span id="" class="sum">{{sum}}</span>
                        <small class=""> -</small>
                    </td>
                </tr>
            </span>
        </div>


      <!--<div class="table">-->
      <!--<tr>-->
      <!--<td>-->
      <!--<span class="form-control-label text-left">Kedvezmény</span>-->
      <!--</td>-->
      <!--<td class="col col-md-5 text-right text-nowrap extensionLineX">-->
      <!--<span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>-->
      <!--<small class=""> -</small>-->
      <!--</td>-->
      <!--</tr>-->

      <!--</div>-->


      <!--<div class="row" v-if="Number(discount_price)>0">-->
      <!--<div class="col col-md-7 extensionLineX">-->
      <!--<span class="form-control-label">Kedvezmény</span>-->
      <!--</div>-->
      <!--<div class="col col-md-5 text-right text-nowrap extensionLineX">-->
      <!--<span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>-->
      <!--<small class=""> -</small>-->
      <!--</div>-->
      <!--</div>-->

      <!--<div class="row" v-if="Number(sum)>0">-->
      <!--<div class="col col-md-7 extensionLineX">-->
      <!--<span class="form-control-label">Teljes összeg</span>-->
      <!--</div>-->
      <!--<div class="col col-md-5 text-right text-nowrap extensionLineX">-->
      <!--<span id="Xdiscount_type" class="sum">{{sum}}</span>-->
      <!--<small class=""> -</small>-->
      <!--</div>-->
      <!--</div>-->

      <!--<span v-if="visible">{{title}}</span>-->
      <!--<option v-for="purcaseItem in purcaseItems" :value="monthOption.value">{{monthOption.text}}</option>-->

  </div>
</template>


<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
    //    import EventBus from '@/helper/EventBus';

    export default {
        name: 'BasketDisplayer',
//        roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        data() {
            return {
                prefix: "",
                suffix: "",
                data: {},
                purcaseItems: [],
                purcaseItemsExtend: [],
                discount_price: "",
                sum: "",
            };
        },
        props: {
            discount: {
                type: String,
                default: '0',
            },
            justDisplay: {
                type: String,
                default: 'false',
            },
        },
        watch: {
            discount: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
            purcaseItems: function (newData, oldData) {
                const modul = this;
                const purcaseItemsExtend = [];
                Array.prototype.forEach.call(newData, function (e) {
                    const eCopied = Object.assign({}, e);
                    purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementById(e.itemKey)));
                })
                this.purcaseItemsExtend = purcaseItemsExtend;
                modul.$eventBus.$emit('globalSetPurcaseItems', newData);
                modul.makeBasketCalculation();
            },
        },
        mounted() {
            const modul = this;
            console.log("BasketDisplayer");
            modul.prefix=Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix=Helper.getMoneyDefaultDisplaySuffix();
            modul.$eventBus.$on('globalReadElement', this.globalReadElementEventHandler);
            modul.$eventBus.$on('globalSetPurcaseElements', this.globalSetPurcaseElementsEventHandler);
            modul.$eventBus.$on('globalAddPurcaseElement', this.globalAddPurcaseElementEventHandler);
            modul.data = {};
            modul.purcaseItems = [];
            modul.purcaseItemsExtend = [];
            modul.discount_price = "";
            modul.sum = "";
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('globalReadElement');
            modul.$eventBus.$off('globalSetPurcaseElements');
            modul.$eventBus.$off('globalAddPurcaseElement');
            modul.data = {};
            modul.purcaseItems = [];
            modul.purcaseItemsExtend = [];
            modul.discount_price = "";
            modul.sum = "";
        },
        methods: {

            handlePurcaseItems(newData, oldData){
                const modul = this;
                const purcaseItemsExtend = [];
                Array.prototype.forEach.call(newData, function (e) {
                    const eCopied = Object.assign({}, e);
                    purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementById(e.itemKey)));
                })
                this.purcaseItemsExtend = purcaseItemsExtend;
                modul.$eventBus.$emit('globalSetPurcaseItems', newData);
                modul.makeBasketCalculation();

            },

            makeBasketCalculation(){
                const modul = this;

                let sum = 0;
                modul.purcaseItemsExtend.forEach(function (item) {

                    let val = item.itemValue;
//                    let item = modul.getItemById(e.itemKey);
                    if (Number(item.type) === 1) {
                        if (val && Number(val).toString() === val.toString()) {
                            sum += Number(val);
                        }
                    } else if (Number(item.type) === 2) {
                        if (val && Number(val).toString() === val.toString()) {
                            sum += Number(item.default_price) * item.itemValue;
                        }
                    } else if (Number(item.type) === 2) {
                        if (val && Number(val).toString() === val.toString()) {
                            sum += Number(item.default_price) * item.itemValue;
                        }
                    }
                });

                let sumDiscont = 0;
                const discount = modul.discount;
                sumDiscont = parseFloat(100 - Number(discount)) * parseFloat(0.01) * sum;
                sumDiscont = Helper.roundToProjectDecimal(sumDiscont);
                modul.sum = Helper.getFormattedPrice(sumDiscont);
                let discount_price = 0;
                if (discount && Number(discount).toString() === discount.toString() && discount !== 0) {
                    discount_price = Helper.roundToProjectDecimal(( Number(discount)) * parseFloat(0.01) * sum);
                    modul.discount_price = Helper.getFormattedPrice(discount_price);
//                    $('[name="discount_price"]').val(discount_price);
//                    $('.discount_price').html(discount_price);
//                    if (discount_price > 0) {
//                        $('.discountpriceContainer,.discountPercentageContainer').removeClass('d-none');
//                    } else {
//                        $('.discountpriceContainer,.discountPercentageContainer').addClass('d-none');
//                    }
                }
                modul.$eventBus.$emit('globalSetBasketCalculation', {sum: modul.sum, discount_price: modul.discount_price});
            },
            globalAddPurcaseElementEventHandler(element){
                const modul = this;
              console.log("globalAddPurcaseElement - basketdisplayer")
                if (element.hasOwnProperty("itemKey") && element.hasOwnProperty("itemValue")) {
                    let purcaseItems = [];
                    modul.purcaseItems.forEach(function (e) {
                        purcaseItems.push(e);
                    });
                    purcaseItems.push({itemKey: element.itemKey, itemValue: element.itemValue ,itemPrice: element.itemPrice, itemCountnum: element.itemCountnum, itemSumPrice: element.itemSumPrice });
                    modul.purcaseItems = purcaseItems;
//                    modul.$eventBus.$emit('globalSetPurcaseItems', modul.purcaseItems);
                }
            },
            globalSetPurcaseElementsEventHandler(elements){
                const modul = this;
//                modul.purcaseItems = elements;
//                modul.$eventBus.$emit('globalSetPurcaseItems', modul.purcaseItems);
                const purcaseItems = [];
                elements.forEach(function (e) {
                    purcaseItems.push(Object.assign({}, e));
                });
                modul.purcaseItems = purcaseItems;
                modul.handlePurcaseItems(purcaseItems, modul.purcaseItems)
//                modul.purcaseItems = [];
//                setTimeout(function () {
//                    modul.purcaseItems = purcaseItems;
//                }, 0)
            },
            globalReadElementEventHandler(barcode){
                const modul = this;
                modul.getElementByBarcode(function (err, res) {
                    if (res && res[0] && res[0].id) {
                        const item = {itemKey: res[0].id, itemValue: "1"};
                        const dbElement = res[0];
                        item.itemPrice=Number(dbElement.default_price);
                        item.itemSumPrice=Number(dbElement.default_price);
                        item.itemCountnum=1;
                        let purcaseItems = [];
                        modul.purcaseItems.forEach(function (e) {
                            purcaseItems.push(e);
                        });
                        purcaseItems.push(item);
                        modul.purcaseItems = purcaseItems;
                        modul.$eventBus.$emit('globalSetPurcaseItems', modul.purcaseItems);

                    }
                }, barcode);
            },
            getElementByBarcode: function (cb, barcode) {
                const modul = this;
                window.db.select(
                    function (err, res) {
                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
//                                Array.prototype.forEach.call(arrRes, function (e, i) {
//                                    modul.purcaseItems.push(e);
//                                })
//                            }
//                        }
                        cb(err, arrRes)
                    }
                    , "element", "*", "barcode=" + window.db.quote(barcode) + " AND (`deleted` = 0 OR `deleted` = '0') AND (`type` = 2 OR `type` = '2')");
            },
            getElementById: function (id) {
                const modul = this;
                const elements = window.db.select(
                    function (err, res) {
                    }
                    , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0') "); // AND (`type` = 2 OR `type` = '2')
                let element = {};
                if (elements && elements[0] && elements[0].id) {
                    element = elements[0];
                }
                return element;
            },
            delrow: function (id) {
                const modul = this;
                Array.prototype.forEach.call(modul.purcaseItems, function (e, i) {
                    if (Number(e.itemKey) === Number(id)) {
                        delete(modul.purcaseItems[i]);
                    }
                });
                const purcaseItems = [];
                modul.purcaseItems.forEach(function (e) {
                    purcaseItems.push(e);
                });
                modul.purcaseItems = purcaseItems;
            },
//
//            setSellElements: function () {
//                const that = this;
//                let content = "";
//                let elements = this.elements;
//                let sellElements = this.sellElements;
//                if (Array.isArray(elements)) {
//                    // a vásárolható elemeken...
//                    for (let row in elements) {
//                        if (elements.hasOwnProperty(row)) {
//                            // a elemeket nullázzuk.
//                            for (let rowSE in sellElements) {
//                                if (sellElements.hasOwnProperty(rowSE)) {
//                                    elements[row].price = "";
//                                }
//                            }
//                            // a vásárolt elemekkel beletöltünk...
//                            for (let rowSE in sellElements) {
//                                if (sellElements.hasOwnProperty(rowSE)) {
//                                    if (sellElements[rowSE].id_element === elements[row].id) {
//                                        elements[row].price = sellElements[rowSE].price;
//                                    }
//                                }
//                            }
//                            // Ha nem volt érték, akkor legyen üres
//                            if (!elements[row].price) {
//                                elements[row].price = ""
//                            }
//                            const iconclass = elements[row].iconclass;
//                            let strIconStyle = '';
//                            if (elements[row].iconbgcolor && (elements[row].iconbgcolor !== '' ) && elements[row].iconfgcolor && (elements[row].iconfgcolor !== '')) {
//                                strIconStyle = 'style="background-color:' + elements[row].iconbgcolor + '; color:' + elements[row].iconfgcolor + ';"';
//                            }
//                            content += //'<div class="row form-group box-container">' +
//                                '<div class="colX">' +
//                                '<label for="text-input' + elements[row].id + '" class=" box box-x btn-box elementType-' + elements[row].type + '">' +
//                                '<span class="iconDefault ' + iconclass + '" ' + strIconStyle + '></span><span class="textLabel">' + elements[row].name + '</span>' +
//                                // '' + elements[row].name + '' +
//                                '</label>' +
//                                // '</div>' +
//                                // '<div class="">' +
//                                '<input value="' + elements[row].price + '" type="text" id="text-input' + elements[row].id + '" name="element-' + elements[row].id + '" placeholder="" class="d-none-nf emptynumber form-controlX element kbnumber" data-id="' + elements[row].id + '">'
//                                + '</div>' //+'</div>'
//                            ;
//                        }
//                    }
//                }
//                $(".elementProductGroupPricesContainer").html(content);
//                that.bindEventsToSumCount();
//                that.offValidateInputs();
//                that.onValidateInputs($(that.template).find('input[type="text"],input[type="email"],input[type="password"],select,textarea'));
//            },


        },
        components: {
//            EventBus,
        },
    };
</script>

<style scoped>
    .table {
        display: table;
    }
    body .table td, body .table th
    {
        border-top:none;
    }



    /*@media print {*/
        body .table td, body .table th{
            padding:0;
        }
        body .table {
            margin-bottom: 0;
            padding:0;
        }
    /*}*/

</style>

